import { CurationHeader } from '@/pages/curation/components/CurationHeader'
import { CurationProvider, useCuration } from '@/contexts/curation'
import { CurationFilters } from '@/utils/curation'
import { Outlet, useLocation } from 'react-router-dom'
import { FilterBreadcrumb } from '@/components/FilterBreadcrumb'

function CurationPageContent() {
  const location = useLocation()
  const { filters, setFilters } = useCuration()
  
  const getActiveTab = () => {
    if (location.pathname.includes('/boards')) return 'boards'
    if (location.pathname.includes('/metrics')) return 'metrics'
    return 'boards'
  }

  const activeTab = getActiveTab()

  const handleRemoveFilter = (type: string, value?: string) => {
    if (type === 'territories' && value) {
      const currentIds = filters.territories?.split(';').filter(Boolean) || []
      const newIds = currentIds.filter(id => id !== value)
      setFilters({ ...filters, territories: newIds.join(';') || '' })
    } else if (type === 'contexts' && value) {
      const currentIds = filters.contexts?.split(';').filter(Boolean) || []
      const newIds = currentIds.filter(id => id !== value)
      setFilters({ ...filters, contexts: newIds.join(';') || '' })
    } else if (type === 'topics' && value) {
      const currentIds = filters.topics?.split(';').filter(Boolean) || []
      const newIds = currentIds.filter(id => id !== value)
      setFilters({ ...filters, topics: newIds.join(';') || '' })
    } else if (type === 'partners' && value) {
      const currentIds = filters.partners?.split(';').filter(Boolean) || []
      const newIds = currentIds.filter(id => id !== value)
      setFilters({ ...filters, partners: newIds.join(';') || '' })
    } else if (type === 'sources' && value) {
      const currentIds = filters.sources?.split(';').filter(Boolean) || []
      const newIds = currentIds.filter(id => id !== value)
      setFilters({ ...filters, sources: newIds.join(';') || '' })
    } else if (type === 'favorited') {
      setFilters({ ...filters, favorited: undefined })
    } else if (type === 'created_by') {
      setFilters({ ...filters, created_by: undefined })
    }
  }

  return (
    <div className="h-full container mx-auto max-w-7xl flex flex-col">
      <div className="p-6">
        <CurationHeader activeTab={activeTab} />
        <div className="mt-4">
          <FilterBreadcrumb
            filters={filters}
            onRemoveFilter={handleRemoveFilter}
          />
        </div>
      </div>
      <div className="flex flex-1 px-6 pb-6">
        <Outlet />
      </div>
    </div>
  )
}

export default function CurationPage() {
  const initialFilters: CurationFilters = {
    search: '',
    period: 'ALL',
    territories: '',
    contexts: '',
    topics: '',
    partners: '',
    sources: '',
    favorited: undefined,
    created_by: undefined,
  }

  return (
    <CurationProvider filters={initialFilters}>
      <CurationPageContent />
    </CurationProvider>
  )
}
